import App from "modujs";
import modules from "./modules";
import "./freeform/previewFix.js";

const app = new App({ modules });

if (typeof window !== "undefined") {
  window.__modujsApp = app;
}

const init = () => {
  app.init(app);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

export default app;
